import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Stack,
  Typography,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { uploadFiles } from 'src/api/files/uploadFiles';
import { listFiles } from 'src/api/files/listFiles';
import { deleteFile } from 'src/api/files/deleteFile';

export default function ImageLibraryPage() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState<{ blobUrl: string; blobName: string }[]>(
    []
  );

  useEffect(() => {
    listFiles()
      .then((response) => {
        setImages(response.files);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const deleteImageHandler = async (value: string) => {
    await deleteFile(value);
    window.location.reload();
  };

  const handleUploadFiles = async (event: any) => {
    if (event.target.files.length > 0) {
      setLoading(true);
      const files = Array.from(event.target.files) as File[];

      try {
        await uploadFiles(files);
        const response = await listFiles();
        setImages(response.files);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Image Library</title>
      </Helmet>

      <Container>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
        >
          <Typography variant='h4' gutterBottom>
            Image Library
          </Typography>
          <Button
            variant='contained'
            component='label'
            startIcon={<Iconify icon='eva:plus-fill' />}
          >
            Upload Files
            <input
              hidden
              accept='image/*'
              multiple
              type='file'
              onChange={handleUploadFiles}
            />
          </Button>
        </Stack>

        <Card sx={{ p: 2 }}>
          {loading ? (
            <Box
              sx={{ display: 'flex', justifyContent: 'center' }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : images === null ? (
            <Typography variant='h6' gutterBottom>
              No images found
            </Typography>
          ) : (
            <ImageList cols={4} rowHeight={164}>
              {images.map((item, index: number) => (
                <ImageListItem key={index}>
                  <img
                    src={item.blobUrl}
                    srcSet={item.blobUrl}
                    alt='library'
                    loading='lazy'
                  />
                  <ImageListItemBar
                    title={item.blobName}
                    subtitle={''}
                    actionIcon={
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${item.blobName}`}
                        value={item.blobName}
                        onClick={() => {
                          deleteImageHandler(item.blobName);
                        }}
                      >
                        <Iconify icon='eva:trash-2-outline' />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </Card>
      </Container>
    </>
  );
}
